import React, { Component } from 'react';
import { isEqual } from 'lodash';

import analyticService from '../../../../services/analytics';
import { session } from '../../../../services/session';
import { getClass } from '../../../../utils/component-helpers';
import { paymentsService } from '../../account/payments-service';

import Constants from '../../../../app.constants';
import NavItem from './nav-item';

import hamburgerIcon from '../../../../images/icons/hamburger-white-on-blue.svg';
import narrativLogo from '../../../../images/logos/narrativ_icon_4.png';
import './nav-sidebar.scss';

class NavSidebar extends Component {
  constructor(props) {
    super(props);

    this.Session = session;
    this.AnalyticService = analyticService;

    const adminMenu = [
      {
        label: 'Home',
        path: '/dashboard',
      },
      {
        label: 'Creator Workspace',
        path: '/creator-workspace',
        flag: 'creatorWorkspace',
        flagValue: true,
        icon: 'document',
        subnav: [{ label: 'Content Manager', path: '/content-manager' }],
      },
      {
        label: 'Bid Center',
        path: '/bid-center',
        subnav: [
          { label: 'Merchant Overview V2', path: '/merch-ed-overview' },
          { label: 'Publisher Overview', path: '/publisher-overview' },
          { label: 'Auction Config', path: '/auction-config-editor' },
          { label: 'Bulk Match Page', path: '/bulk-match' },
        ],
      },
      {
        label: 'Product Match',
        path: '/product-match',
        subnav: [
          { label: 'Smartlink Search', path: '/smartlink-search' },
          { label: 'New Product', path: '/new-product' },
        ],
      },
      {
        label: 'Smartlink Management',
        path: '/smartlinks/editor',
      },
      {
        label: 'Accounts',
        path: '/accounts',
        subnav: [
          { label: 'Accounts', path: '/all', flag: 'accountSetupV2', flagValue: false },
          { label: 'All Accounts', path: '/overview', flag: 'accountSetupV2', flagValue: true },
          { label: 'Widgets V1', path: '/widgets' },
          { label: 'Widgets V2', path: '/widgets/jstags' },
        ],
      },
      {
        label: 'Collections',
        path: '/collections',
        featureToggle: true,
      },
    ];

    const productMatchMenu = [
      {
        label: 'Smartlink Management',
        path: '/smartlinks/editor',
      },
      {
        label: 'Product Match',
        path: '/product-match',
        subnav: [
          { label: 'Smartlink Search', path: '/smartlink-search' },
          { label: 'New Product', path: '/new-product' },
        ],
      },
    ];

    const merchantMenu = [
      {
        label: 'Home',
        path: '/desk',
      },
      {
        label: 'Competitive Research',
        path: '/article-search',
        subnav: [
          { label: 'Keywords', path: '/keyword' },
          { label: 'Brands', path: '/brand' },
          { label: 'Products', path: '/product' },
        ],
        featureToggle: true,
      },
      {
        label: 'Campaign Strategy',
        path: '/campaigns',
        subnav: [
          { label: 'Launch New', path: '/new' },
          { label: 'Optimize', path: '/optimize' },
        ],
        hiddenForAllSites: true,
      },
      {
        label: 'Campaign Center',
        path: '/campaign-center',
        featureToggle: true,
        flag: 'campaignCenter',
        flagValue: true,
        beta: true,
      },
      {
        label: 'Track Performance',
        path: '/megatables',
        subnav: [
          { label: 'Campaigns', path: '/campaign-performance', hiddenForAllSites: true },
          { label: 'Stories', path: '/articles' },
          { label: 'Recommendations', path: '/recommendations' },
          { label: 'Publishers', path: '/publishers' },
        ],
      },
      // Budgets have been disabled until we determine if feature will be ported over to n-dash
      // or if we'll drop support entirely.
      /* {
				label: 'Budget',
				path: '/budgets',
				hiddenForAllSites: true,
			}, */
    ];

    this.creatorMenu = [
      {
        label: 'Create Narrativ Links',
        path: '/link-creation',
        hiddenForAllSites: true,
        mobileOnly: true,
        creatorOnly: true,
      },
    ];

    const publisherMenu = [
      {
        label: 'Home',
        path: '/dashboard',
      },
      {
        label: 'Orders',
        path: '/orders',
        flag: 'ordersPageMvp',
        flagValue: true,
      },
      {
        label: 'Links',
        path: '/links',
        flag: 'linksNavitem',
        flagValue: true,
        subnav: [
          { label: 'My Links', path: '/my-links' },
          { label: 'Create Links', path: '/create-links/select-story' },
        ],
      },
      {
        label: 'Research',
        path: '/new-recs',
        subnav: [
          {
            label: 'Rates and Strategies',
            path: '/rates',
            hiddenForAllSites: true,
          },
          { label: 'Products', path: '/product-research' },
          { label: 'Search Trends', path: '/search-trends' },
        ],
      },
      {
        label: 'Update Recommendations',
        path: '/smartlinks/editor',
        flag: 'smartlinkEditor',
        flagValue: true,
      },
      {
        label: 'Track',
        path: '/megatables',
        subnav: [
          { label: 'Stories', path: '/articles' },
          { label: 'Recommendations', path: '/smartlinks' },
          { label: 'Merchants', path: '/merchants' },
          { label: 'Products Purchased', path: '/products' },
        ],
      },
      {
        label: 'Analytics',
        path: '/analytics',
        flag: 'newNavigationBar',
        flagValue: true,
      },
    ];

    const newPublisherMenu = [
      {
        label: 'Home',
        path: '/dashboard',
        icon: 'home',
      },
      {
        label: 'Home V2',
        path: '/home-page',
        flag: 'homePageV2',
        flagValue: true,
      },
      {
        label: 'Orders',
        path: '/orders',
        flag: 'ordersPageMvp',
        flagValue: true,
        icon: 'document',
      },
      {
        label: 'Links',
        path: '/links',
        icon: 'lightningBolt',
        flag: 'linksNavitem',
        flagValue: true,
        subnav: [
          { label: 'My Links', path: '/my-links' },
          { label: 'Create Links', path: '/create-links/select-story' },
        ],
      },
      {
        label: 'Research',
        path: '/new-recs',
        icon: 'shoppingBag',
        subnav: [
          {
            label: 'Rates and Strategies',
            path: '/rates',
            hiddenForAllSites: true,
          },
          { label: 'Products', path: '/product-research' },
          { label: 'Search Trends', path: '/search-trends' },
        ],
      },
      {
        label: 'Update Recommendations',
        path: '/smartlinks/editor',
        flag: 'smartlinkEditor',
        flagValue: true,
      },
      {
        label: 'Payments',
        path: '/payments',
        flag: 'paymentsNavitem',
        flagValue: true,
        forBillingUsers: true,
        icon: 'purse',
        subnav: [
          { label: 'Earnings', path: '/earnings' },
          { label: 'Setup', path: '/payment-setup' },
        ],
      },
      {
        label: 'Analytics',
        path: '/analytics',
        flag: 'newNavigationBar',
        flagValue: true,
        icon: 'barGraph',
      },
    ];

    this.menuMap = {
      admin: adminMenu,
      product_match: productMatchMenu,
      publisher: publisherMenu,
      newPublisherMenu,
      merchant: merchantMenu,
    };

    const menu =
      this.props.userRole === 'publisher'
        ? this.props.flags && this.props.flags.newNavigationBar
          ? this.menuMap.newPublisherMenu
          : this.menuMap.publisher
        : null;

    this.state = {
      // Bind to state so that component re-renders when this value updates
      navItems: this.getNavItems(menu) || [],
      orgPath: '',
      accountLink: null,
    };
  }

  async componentDidUpdate(prevProps) {
    if (
      prevProps.userRole !== this.props.userRole ||
      prevProps.location.pathname !== this.props.location.pathname
    ) {
      this.setState({
        navItems: this.expandSubnavs(this.menuMap[this.props.userRole]),
      });
    }

    // TODO: make session not mutate when its orgId changes and move this logic to Main.js
    if (this.props.flags && Object.keys(this.props.flags).length) {
      const publisherType =
        session.publisher_type === 1
          ? 'publisher'
          : session.publisher_type === 2
          ? 'creator'
          : null;

      this.props.ldClient.identify(
        {
          key: `${session.userId}`,
          custom: {
            orgId: session.orgId,
            userRole: session.userRole,
            pubType: publisherType,
            isAdmin: session.isAdmin,
          },
        },
        null,
      );
    }

    if (
      (!isEqual(this.props.flags, prevProps.flags) ||
        prevProps.userRole !== this.props.userRole ||
        prevProps.location.pathname !== this.props.location.pathname) &&
      this.props.userRole === 'publisher'
    ) {
      const menu =
        this.props.flags && this.props.flags.newNavigationBar
          ? this.menuMap.newPublisherMenu
          : this.menuMap.publisher;
      this.setState({
        navItems: this.getNavItems(menu),
      });
    }

    if (
      !isEqual(this.props.flags, prevProps.flags) &&
      this.props.flags.billingFeatures &&
      paymentsService.checkIfBillingUser()
    ) {
      const res = await paymentsService.getAccountLink(this.props.currentUser.orgId);

      this.setState({ accountLink: res.data.data[0] });
    }
  }

  expandSubnavs(navItems) {
    // Always expand all of the subnavs
    return navItems.map(item => {
      item.subnavExpanded = true;
      return item;
    });
  }

  getNavItems(menu) {
    // Hide everything but mobile link creation for creator mobile screens
    return this.props.isMobile && session.publisher_type === 2
      ? this.creatorMenu
      : this.expandSubnavs(menu || this.menuMap[this.props.userRole]);
  }

  onSubnavItemClicked(event, navItem) {
    // Only send GA event if Megatable subnav clicked
    const subnavLabel = event.currentTarget.innerText;
    if (navItem.label === 'Insights') {
      this.AnalyticService.trackEvent('Navigation Bar', 'Click', `${subnavLabel} Insights`);
    }

    event.stopPropagation();
    // Allow clicking directly on item or nearby it
    const path =
      event.target.getAttribute('data-path') || event.currentTarget.getAttribute('data-path');
    this.redirectToPath(path);
  }

  onNavItemClicked(navItem) {
    // We want to handle redirect in this component instead of NavItem
    this.AnalyticService.trackEvent('Navigation Bar', 'Click', navItem.label);

    if (!navItem.subnav) {
      this.redirectToPath(navItem.path);
    }
  }

  /* Helper functions */
  getOrgPath(userRole, pathname) {
    let orgPath;

    if (userRole === 'admin') {
      orgPath = 'admin';
    } else {
      // Need to escape '\' bc constructing RexExp from string
      // eslint-disable-next-line no-useless-escape
      orgPath = pathname.match(new RegExp(`${userRole}\/\\d+`));
      // eslint-disable-next-line no-useless-escape
      const noOrgIdRegex = new RegExp(`${userRole}\/\\D+`);
      orgPath = orgPath
        ? orgPath[0]
        : noOrgIdRegex.test(pathname)
        ? `${userRole}/${this.Session.orgId}`
        : '';
    }

    return orgPath;
  }

  redirectToPath(path) {
    const orgPath = this.getOrgPath(this.props.userRole, this.props.location.pathname);
    const isBestBuy = this.Session.userRole === 'merchants' && this.Session.orgId === 1125;
    const isStagingMerch =
      this.Session.userId === 233649 && ['staging', 'local'].includes(Constants.ENV);
    const isStagingPubTestUser =
      this.Session.userId === 233638 && ['staging', 'local'].includes(Constants.ENV);
    const isReleasePubTestUser =
      [2458, 2464].includes(session.userId) && ['release'].includes(Constants.ENV);

    // Consolidating special user access into a single boolean
    const isSpecialUser =
      isBestBuy || isStagingMerch || isStagingPubTestUser || isReleasePubTestUser;
    /*
     * exposedPaths: v2 pages available to publishers or merchants
     * restrictedPaths: v2 pages only available to admins, feature toggled users, for QA purposes
     */

    if (
      this.props.exposedPaths.includes(path) ||
      (this.props.restrictedPaths.includes(path) && (this.props.isAdmin || isSpecialUser)) ||
      (this.props.productMatchPaths.includes(path) && this.Session.userRole === 'product_match')
    ) {
      this.props.history.push(`/v2/${orgPath}${path}`);
    } else if (this.props.wooshSpaRoutes.includes(path)) {
      window.location = `/#${orgPath ? `/${orgPath}` : '/admin'}${path}`;
    } else {
      this.props.history.push('/');
    }
  }

  toggleFeature() {
    session.update({ isAdminView: !session.isAdminView });
    this.props.toggleAdminView();
  }

  render() {
    const header = (
      <div className="header">
        <div className="hamburger" onClick={this.props.toggleNavSidebar}>
          <img src={hamburgerIcon} alt="Expand/collapse nav" />
        </div>
        <a className="logo" href="/v2/">
          <img src={narrativLogo} alt="Narrativ" />
        </a>
      </div>
    );

    const featureToggle = session.isAdmin ? (
      <div className="feature-toggle" onClick={() => this.toggleFeature()}>
        {this.props.isAdminView ? 'Seeing new features' : `Seeing what ${this.props.userRole}s see`}
      </div>
    ) : null;

    const isBestBuy = this.Session.userRole === 'merchants' && this.Session.orgId === 1125;
    const isStagingMerch =
      this.Session.userId === 233649 && ['staging', 'local'].includes(Constants.ENV);
    const isStagingPubTestUser =
      this.Session.userId === 233638 && ['staging', 'local'].includes(Constants.ENV);
    const isReleasePubTestUser =
      [2458, 2464].includes(session.userId) && ['release'].includes(Constants.ENV);
    const isPubTestUser = isStagingPubTestUser || isReleasePubTestUser;

    const navItems = this.state.navItems
      // Exclude navItems when viewing allSites
      .filter(navItem => !(session.allSites && navItem.hiddenForAllSites))
      // Exclude desktop-only nav items if on mobile
      .filter(navItem => (navItem.desktopOnly && !this.props.isMobile) || !navItem.desktopOnly)
      // Exclude navItems under feature toggle except StagingMerch for AS, PubFlagUser for NRP
      .filter(
        navItem =>
          !(
            navItem.featureToggle && !(session.isAdminView && session.merchPricingModel !== 'CPA')
          ) ||
          (isStagingMerch && navItem.path === '/article-search') ||
          (isPubTestUser && ['/new-recs'].includes(navItem.path)) ||
          (this.props.flags && this.props.flags[navItem.label.toLowerCase()]),
      )
      // Exclude navItems if not billing user
      .filter(navItem => {
        return navItem.forBillingUsers
          ? paymentsService.checkIfBillingUser() && this.props.flags.billingFeatures
          : true;
      })
      .map((navItem, index) => {
        return (
          <NavItem
            currentUser={this.props.currentUser}
            item={navItem}
            key={index}
            currentPath={this.props.location.pathname}
            onNavItemClicked={() => this.onNavItemClicked(navItem)}
            onSubnavItemClicked={event => this.onSubnavItemClicked(event, navItem)}
            isMobile={this.props.isMobile}
            flags={this.props.flags}
            accountLink={this.state.accountLink}
          ></NavItem>
        );
      });

    return (
      <div
        className={getClass('nav-sidebar', {
          hidden: this.props.navSidebarCollapsed,
          'with-icons': this.props.flags && this.props.flags.newNavigationBar,
        })}
      >
        {header}
        <ul>{navItems}</ul>
        {featureToggle}
      </div>
    );
  }
}

export default NavSidebar;
